import { Form, Success } from './components';

const RenamePortfolioFlow = {
  Form,
  Success,
};

export { RenamePortfolioFlow };
